export default __webpack_public_path__ + "static/media/po-format.8abf06a3.xlsx";